module.exports = __webpack_public_path__ + "static/media/galerija_2014 (42).f47cf0a8.jpg";